import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { ButtonBase } from '@website-builder/model/style/button-base';
import { PanelStyle } from '@website-builder/widgets/panel/model/panel-style';
import { PanelMediaStyle } from '@website-builder/widgets/panel/model/panel-media-style';
import { PanelTitleStyle } from '@website-builder/widgets/panel/model/panel-title-style';
import { PanelContentStyle } from '@website-builder/widgets/panel/model/panel-content-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';
import { ButtonActionType } from '@website-builder/widgets/button/model/button-action-type.enum';

export class PanelWidget extends BaseWidget<PanelStyle> {
  readonly type = BuilderElementType.Panel;
  name = '';
  title = 'Title';
  subtitle = 'Subtitle';
  content = '';
  imageUrl: string;
  videoUrl: string;
  buttonLink = new TbLink();
  buttonContent = '';
  buttonActionType = ButtonActionType.LINK;
  style = new PanelStyle();
  mediaStyle = new PanelMediaStyle();
  titleStyle = new PanelTitleStyle();
  subtitleStyle = new PanelTitleStyle();
  contentStyle = new PanelContentStyle();
  buttonStyle = new ButtonBase();

  static normalizeInPlace(widget: PanelWidget): PanelWidget {
    const pureWidget = new PanelWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.name = widget.name ?? pureWidget.name;
    widget.title = widget.title ?? pureWidget.title;
    widget.subtitle = widget.subtitle ?? pureWidget.subtitle;
    widget.content = widget.content ?? pureWidget.content;
    widget.imageUrl = widget.imageUrl ?? pureWidget.imageUrl;
    widget.videoUrl = widget.videoUrl ?? pureWidget.videoUrl;
    widget.buttonContent = (widget.buttonContent || widget.buttonLink?.displayedUrl) ?? pureWidget.buttonContent;
    widget.buttonLink = TbLink.normalizeInPlace(widget.buttonLink ?? pureWidget.buttonLink);
    widget.buttonActionType = widget.buttonActionType ?? pureWidget.buttonActionType;

    widget.style = PanelStyle.normalize(widget.style);
    widget.mediaStyle = PanelMediaStyle.normalize(widget.mediaStyle);
    widget.titleStyle = PanelTitleStyle.normalize(widget.titleStyle);
    widget.subtitleStyle = PanelTitleStyle.normalize(widget.subtitleStyle);
    widget.contentStyle = PanelContentStyle.normalize(widget.contentStyle);
    widget.buttonStyle = ButtonBase.normalize(widget.buttonStyle);

    return widget;
  }
}
